/** Parse and serialize admin UI state stored in the URL fragment (`#key=value&...`). */

export type AdminHashState = Record<string, string>;

export function parseAdminHash(fragment: string | null | undefined): AdminHashState {
  if (!fragment) {
    return {};
  }

  const normalized = fragment.startsWith('#') ? fragment.slice(1) : fragment;
  if (!normalized) {
    return {};
  }

  const state: AdminHashState = {};
  for (const part of normalized.split('&')) {
    if (!part) {
      continue;
    }
    const eq = part.indexOf('=');
    if (eq <= 0) {
      state[decodeURIComponent(part)] = '';
      continue;
    }
    const key = decodeURIComponent(part.slice(0, eq));
    const value = decodeURIComponent(part.slice(eq + 1));
    if (key) {
      state[key] = value;
    }
  }
  return state;
}

export function serializeAdminHash(state: AdminHashState): string | undefined {
  const parts: string[] = [];
  for (const [key, value] of Object.entries(state)) {
    if (!key || value == null || value === '') {
      continue;
    }
    parts.push(`${encodeURIComponent(key)}=${encodeURIComponent(value)}`);
  }
  return parts.length ? parts.join('&') : undefined;
}

export function adminHashesEqual(
  left: string | null | undefined,
  right: string | null | undefined,
): boolean {
  const a = serializeAdminHash(parseAdminHash(left)) ?? '';
  const b = serializeAdminHash(parseAdminHash(right)) ?? '';
  return a === b;
}
